"use client";

import { AboutSection } from "@/components/sections/about-section";
import { GallerySection } from "@/components/sections/gallery-section";
import HeroSection from "@/components/sections/hero-section";
import { MenuSection } from "@/components/sections/menu-section";
import { ReachUsSection } from "@/components/sections/reach-us-section";

export default function Page() {
  return (
    <>
      <div
        id="home"
        className="min-h-screen bg-slate-900 relative overflow-hidden"
      >
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: "url('/images/hero-horizontal.jpeg')",
          }}
        >
          <div className="absolute inset-0 bg-slate-900/70" />
        </div>
        {/* Hero Section */}
        <HeroSection />
      </div>

      <div id="about">
        <AboutSection />
      </div>
      <div id="menu">
        <MenuSection />
      </div>
      <div id="gallery">
        <GallerySection />
      </div>
      <div id="program">
        <ReachUsSection />
      </div>
      {/* Footer now rendered from layout */}
    </>
  );
}
